import { Colors } from "@/enums/Colors";
import { useResponsive } from "@/hooks/useResponsive";
import { Box, Button, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CloseIcon } from "../utils/icons/CloseIcon";

interface TransferFileMessageProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default function TransferFileMessage(props: TransferFileMessageProps) {
  const { t } = useTranslation("virtualDataRooms");
  const { isMobile } = useResponsive();

  return (
    <StyledTransferFileMessage showTransferFileMessage={props.open} isMobile={isMobile}>
      <Box sx={{ position: "relative", height: "0px" }}>
        <Button
          disableRipple
          onClick={() => props.setOpen(false)}
          sx={{
            position: "absolute",
            width: "fit-content",
            top: { xs: "-8px", sm: "-12px" },
            right: { xs: "-16px", sm: "-23px" },
            padding: "0px",
            minWidth: "0px",
          }}
        >
          <CloseIcon />
        </Button>
      </Box>
      <Typography
        sx={{
          color: Colors.LAZO_PURPLE,
          fontSize: { xs: "0.75rem", sm: "0.875rem" },
          lineHeight: { xs: "1.2", sm: "1.4" },
        }}
      >
        {t("transferFileMessage.description")}
      </Typography>
    </StyledTransferFileMessage>
  );
}

const StyledTransferFileMessage = styled(Box, {
  shouldForwardProp: (prop) => prop !== "showTransferFileMessage" && prop !== "isMobile",
})<{
  showTransferFileMessage?: boolean;
  isMobile?: boolean;
}>(({ theme, showTransferFileMessage, isMobile }) => ({
  position: "absolute",
  bottom: "10px",
  left: isMobile ? "50%" : "35%",
  transform: isMobile ? "translateX(-50%)" : "none",
  width: isMobile ? "90%" : "auto",
  maxWidth: isMobile ? "300px" : "none",
  backgroundColor: Colors.WHITE,
  borderRadius: "12px",
  display: "flex",
  opacity: showTransferFileMessage ? 1 : 0,
  transition: "opacity 0.5s ease-in-out",
  padding: isMobile ? "12px 20px" : "18px 30px",
  flexDirection: "column",
  boxShadow: "0px 0.25rem 0.675rem 0px #00000029",
  zIndex: theme.zIndex.drawer,
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.75rem",
  },
}));
